import { Helper } from '../common';
import { CategoryConfiguration } from './';

export class Category {
    guid: string;
    name: string;
    configuration: CategoryConfiguration;
    sortOrder: number;

    constructor() {
        this.guid = Helper.getGuid();
        this.configuration = new CategoryConfiguration();
    }

    serialize(): any {
        const self = this;
        const result: any = {
            guid: self.guid,
            name: self.name,
            sortOrder: self.sortOrder,
        };
        result.configuration = CategoryConfiguration.serialize(this.configuration);
        return result;
    }
}